import React from 'react'
import BlurText from "../BlurText/BlurText";

function Inicioseguridad() {
  return (
    <div className='hero' id='seguridad'>
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="/media/seguridad-hero.jpg"
        className="hero__video"
      >
        <source src="/media/seguridad-hero.mp4" type="video/mp4" />
      </video>

      <div className="hero__overlay" />
      <div className="hero__grain" />

      <div className="hero__content hero__content--fade">
        <h1 className="hero__title hero__title--blur">
          <BlurText
            text="SEGURIDAD Y MEDIOAMBIENTE"
            delay={120}
            animateBy="words"
            direction="top"
            className="hero__blur"
          />
        </h1>
      </div>

      <div className="hero__scroll">
        <span className="hero__scrollLabel">SCROLL</span>
        <span className="hero__scrollLine" />
      </div>
    </div>
  )
}

export default Inicioseguridad
